import {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    object,
    moreNav,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
} from './ThirdMapping';

var entitiesTabs = [
    {
        label: Loc.g('Activité'),
        value: 'activity',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Éléments épinglés'),
        value: 'pinned',
        entities: ['task', 'event', 'annotation', 'email', 'phonecall', 'people', 'marketing'],
    },
    {
        label: Loc.g('Commentaires'),
        value: 'note',
        entities: ['annotation'],
        databot: 'pure-delivery-overview__activity--comment-list',
    },
    {
        label: Loc.g('Emails'),
        value: 'email',
        entities: ['email'],
        databot: 'pure-delivery-overview__activity--email-list',
    },
    {
        label: Loc.g('Tâches'),
        value: 'task',
        entities: ['task'],
        databot: 'pure-delivery-overview__activity--task-list',
    },
    {
        label: Loc.g('Evènements'),
        value: 'event',
        entities: ['event'],
        databot: 'pure-delivery-overview__activity--event-list',
    },
    {
        label: Loc.g('Appels'),
        value: 'phonecall',
        entities: ['phonecall'],
        databot: 'pure-delivery-overview__activity--call-list',
    },
    {
        label: Loc.g('Marketing'),
        value: 'marketing',
        entities: ['marketing'],
        databot: 'pure-delivery-overview__activity--marketing-list',
    },
];

var entitiesGroups = [
    {
        label: Loc.g('Activité'),
        value: 'clientActivity',
        entities: [
            'task',
            'event',
            'annotation',
            'email',
            'phonecall',
            'client',
            'timetracking',
            'ticket',
            'snippettracking',
            'marketing',
        ],
    },
    {
        label: Loc.g('Prospection'),
        value: 'prospection',
        entities: ['campaign', 'opportunity', 'estimate', 'propdocument'],
    },
    {
        type: 'component',
        component: 'timeline-author-filter',
        label: Loc.g('Collaborateurs'),
        value: 'authors',
        filter: true,
        entities: [],
        display: 'block',
    },
];

var defaultEntities = [
    'email',
    'phonecall',
    'client',
    'annotation',
    'event',
    'task',
    'timetracking',
    'ticket',
    'campaign',
    'opportunity',
    'estimate',
    'propdocument',
    'snippettracking',
    'marketing',
];

var forcedLabel = [
    {
        value: 'document',
        label: Loc.g('Mises à jour'),
    },
];

var availableStatCards = [
    'invoice_third',
    'estimate_third',
    'turnover_third',
    'top_selling_items_third',
    'sales_margin_third',
];

const databots = {
    activity: 'pure-delivery-overview__menu--activity',
    informations: 'pure-delivery-overview__menu--general-info',
    financialactivity: 'pure-delivery-overview__menu--financial-info',
    contacts: 'pure-delivery-overview__menu--contact-linked',
    addresses: 'pure-delivery-overview__menu--address',
    customfields: 'pure-delivery-overview__menu--cf',
    statistics: 'pure-delivery-overview__menu--stat',
    opportunity: 'pure-delivery-overview__menu--opportunity',
    estimate: 'pure-delivery-overview__menu--document',
    invoice: 'pure-delivery-overview__menu--document',
    delivery: 'pure-delivery-overview__menu--document',
    order: 'pure-delivery-overview__menu--document',
    creditnote: 'pure-delivery-overview__menu--document',
    proforma: 'pure-delivery-overview__menu--document',
    payments: 'pure-delivery-overview__menu--payment',
    bankaccount: 'pure-delivery-overview__menu--bank-account',
    recurring: 'pure-delivery-overview__menu--recurring',
    mandates: 'pure-delivery-overview__menu--mandate',
    timetracking: 'pure-delivery-overview__menu--timetracking',
    tickets: 'pure-delivery-overview__menu--ticket',
    project: 'pure-delivery-overview__menu--project',
    proposal: 'pure-delivery-overview__menu--proposal',
    emailingprofile: 'pure-delivery-overview__menu--mailing-list',
    massmailingMailinglist: 'pure-delivery-overview__menu--mailing-list',
    massmailingCampaignList: 'pure-delivery-overview__menu--mailing-list',
    receipts: 'pure-delivery-overview__menu--receipt',
    briefcase: 'pure-delivery-overview__menu--briefcase',
    activitycommentadd: 'pure-delivery-overview__activity--comment-add',
    emailadd: 'pure-delivery-overview__activity--email-add',
    calladd: 'pure-delivery-overview__activity--call-add',
    taskadd: 'pure-delivery-overview__activity--task-add',
    eventadd: 'pure-delivery-overview__activity--event-add',
    generalinfoedit1: 'pure-delivery-overview__section--general-info-edit-1',
    generalinfoedit2: 'pure-delivery-overview__section--general-info-edit-2',
    marketing: 'pure-delivery-overview__section--marketing',
};

export {
    dataMap,
    navMap,
    headerActions,
    contactsActions,
    mainContactsActions,
    addressesActions,
    bankActions,
    backlink,
    routes,
    entitiesTabs,
    defaultEntities,
    entitiesGroups,
    forcedLabel,
    object,
    moreNav,
    availableStatCards,
    databots,
    agendaViewConfig,
    sellsyAdminCommonTabs,
    samTabs,
};
